import { format } from 'date-fns';

/**
 * 将指定的时间对象格式化为对应的字符串格式
 * 字符串格式参数如下:
 * 年:
 * 		YY:		00, 01, 02...., 99
 * 		YYYY:	1900, 1901, 1902...., 2099
 * 国际标准化周编号年份:
 * 		GG:		00, 01, 02...., 99
 * 		GGGG:	1900, 1901, 1902...., 2099
 * 月份:
 * 		M:		1, 2, 3...., 12
 * 		Mo:		1st, 2nd, 3rd...., 12th
 * 		MM:		01, 02, 03....., 12
 * 		MMM:	Jan, Feb, Mar...., Dec
 * 		MMMM:	January, February, March...., December
 * 季度:
 * 		Q:		1, 2, 3, 4
 * 		Qo:		1st, 2nd, 3rd, 4th
 * 国际标准化星期:
 * 		W:		1, 2, 3.... , 53
 * 		Wo:		1st, 2nd, 3rd...., 53rd
 * 		WW:		01, 02, 03..., 53
 * 年份中的天数:
 * 		DDD:	1, 2, 3...., 366
 * 		DDDo:	1st, 2nd, 3rd...., 366th
 * 		DDDD:	001, 002, 003...., 366
 * 月份中的天数:
 * 		D:		1, 2, 3...., 31
 * 		Do:		1st, 2nd, 3rd....., 31st
 * 		DD:		01, 02, 03......., 31
 * 星期中的天数:
 * 		d:		0, 1, 2...., 6
 * 		do:		0th, 1st, 2nd...., 6th
 * 		dd:		Su, Mo, Tu...., Sa
 * 		ddd:	Sun, Mon, Tue...., Sat
 * 		dddd:	Sunday, monday, Tuesday...., Saturday
 * 国际标准化星期中的天数:
 * 		E:		1, 2, 3...., 7
 * 上午/下午:
 * 		A:		AM, PM
 * 		a:		am, pm
 * 		aa:		a.m., p.m.
 * 小时:
 * 		H:		0, 1, 2...., 23
 * 		HH:		00, 01, 02...., 23
 * 		h:		1, 2, 3...., 12
 * 		hh:		01, 02, 03...., 12
 * 分:
 * 		m:		0, 1, 2...., 59
 * 		mm:		00, 01, 02...., 59
 * 秒:
 * 		s:		0, 1, 2...., 59
 * 		ss:		00, 01, 02...., 59
 * 1/10秒:
 * 		S:		0, 1, 2...., 9
 * 1/100秒:
 * 		SS:		00, 01, 02...., 99
 * 1/1000秒(毫秒):
 * 		SSS:	000, 001, 002...., 999
 * 时区:
 * 		Z:		-01:00, +00:00, +01:00...., +12:00
 * 		ZZ:		-0100, +0000, +0100...., +1200
 * 秒时间戳:
 * 		X:		512969520
 * 毫秒时间戳:
 * 		x:		512969520900
 * 
 * @param value 能转换成Date对象的数字, 字符串或者Date对象
 * @param formatStr 要使用的格式化字符串形式
 * @example $date(new Date(2014, 1, 11)) => '2014-02-11'
 */
export default function (value: string | number | Date, formatStr: string = 'YYYY-MM-DD'): string{
	return format(value, formatStr);
}
